import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetsImagePreviewFilterLabel: {
    id: 'assetsImagePreviewFilterLabel',
    defaultMessage: 'Hide File Preview',
    description: 'Label checkbox to hide image previews in the assets table.',
  },
});

export default messages;
